<div class="bl-margin-bottom--40">
  <h2 class="bl-font-size--32 bl-font-weight--900 bl-font-color--black bl-margin-bottom--0">
    {{ page?.customTitleOrDefault | titlecase }}</h2>
    <cu-page-review-cards [page]="page" [flow]="flow"></cu-page-review-cards>
  </div>
